module.exports = __webpack_public_path__ + "img/newtimeshair-review-2.a44ec906.jpg";